// Breadcrumbs — items: Array<{ label, href?, onClick? }>
// Last item is rendered as plain text (current location).

export default function Breadcrumbs({ items = [], separator = '/' }) {
  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 11,
        fontFamily: 'var(--font-mono)',
        color: 'var(--olv-text-tertiary)',
      }}
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1
        return (
          <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {isLast ? (
              <span style={{ color: 'var(--olv-text-primary)' }}>{item.label}</span>
            ) : (
              <a
                href={item.href || '#'}
                onClick={(e) => {
                  if (item.onClick) {
                    e.preventDefault()
                    item.onClick()
                  }
                }}
                style={{
                  color: 'var(--olv-text-secondary)',
                  textDecoration: 'none',
                }}
              >
                {item.label}
              </a>
            )}
            {!isLast && <span aria-hidden style={{ opacity: 0.4 }}>{separator}</span>}
          </span>
        )
      })}
    </nav>
  )
}
